import React from 'react';
import moment from 'moment';
import { API_URL, MEDIA_URL } from '../../request';
import './invoicePdf.css';

let dateFormat = localStorage.getItem('company-details')
    ? JSON.parse(localStorage.getItem('company-details')).dateFormat
    : 'DD.MM.YYYY';

let companyDetails = JSON.parse(localStorage.getItem('company-details'));

class InvoicePDF extends React.Component {
    render() {
        const { generatedInvoice } = this.props;

        let headerLogo = '/invoice-header-logo.jpg';
        let footerLogo
        let footerStemp = null;
        let registeredOffice = null;
        let corporateOffice = null;
        let financeEmail = null;
        let invoiceToDetail = {};
        let bankDetail = {};

        let totalCommission = 0;
        let totalTax = 0;
        let totalGrossReceived = 0;
        let currency = '';
        let totalPaymentBeforeTax = 0;
        let taxStrings = [];
        let combinedTaxString = '';
        let studentBankCharge;
        let totalAfterAdditionalDeduction = 0;
        let totalAddtionalDeduction = 0;

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.headerLogo
        ) {
            const logo = generatedInvoice.invoiceSettings.headerLogo;

            if (Array.isArray(logo) && logo[0] && logo[0].url) {
                headerLogo = MEDIA_URL + logo[0].url;
            } else if (typeof logo === 'string' && logo !== '') {
                headerLogo = MEDIA_URL + logo;
            }
        }

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.footerLogo
        ) {
            const logo = generatedInvoice.invoiceSettings.footerLogo;

            if (Array.isArray(logo) && logo[0] && logo[0].url) {
                footerLogo = MEDIA_URL + logo[0].url;
            } else if (typeof logo === 'string' && logo !== '') {
                footerLogo = MEDIA_URL + logo;
            }
        }

        if (generatedInvoice && generatedInvoice.invoiceToDetail) {
            invoiceToDetail = generatedInvoice.invoiceToDetail
        }

        if (generatedInvoice && generatedInvoice.additionalDeduction && generatedInvoice.additionalTaxDetails) {
            generatedInvoice.additionalTaxDetails.forEach(function (tax) {
                totalAddtionalDeduction += parseFloat(tax.totalTax);
            });
        }

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.signWithStamp
        ) {
            let stamp = generatedInvoice.invoiceSettings.signWithStamp;

            if (Array.isArray(stamp) && stamp[0] && stamp[0].url) {
                footerStemp = MEDIA_URL + stamp[0].url;
            } else if (typeof stamp === 'string' && stamp !== '') {
                footerStemp = MEDIA_URL + stamp;
            }
        }

        if (generatedInvoice && generatedInvoice.companyDetail) {
            bankDetail = generatedInvoice.companyDetail;
        }

        if (generatedInvoice && generatedInvoice.hasBankCharges && generatedInvoice.bankCharges) {
            studentBankCharge = parseFloat(generatedInvoice.bankCharges) / generatedInvoice.invoices.length;
        }

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.corporateOffice
        ) {
            corporateOffice = generatedInvoice.invoiceSettings.corporateOffice;
        }

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.registeredOffice
        ) {
            registeredOffice = generatedInvoice.invoiceSettings.registeredOffice;
        }

        if (
            generatedInvoice &&
            generatedInvoice.invoiceSettings &&
            generatedInvoice.invoiceSettings.financeEmail
        ) {
            financeEmail = generatedInvoice.invoiceSettings.financeEmail;
        }

        if (
            generatedInvoice &&
            generatedInvoice.cpTaxDetails &&
            Array.isArray(generatedInvoice.cpTaxDetails)
        ) {
            generatedInvoice.cpTaxDetails.forEach(function (tax) {
                taxStrings.push(tax.taxName + " (" + tax.taxValue + "%)");
            });
        }

        combinedTaxString = taxStrings.join(', ');

        if (
            generatedInvoice &&
            generatedInvoice.invoices &&
            generatedInvoice.invoices.length > 0
        ) {
            generatedInvoice.invoices.forEach(function (inv) {
                let converted = 0;

                if (generatedInvoice.hasConversionRate) {
                    converted = inv && inv.commissionTotalConverted
                        ? inv.commissionTotalConverted
                        : 0;
                } else {
                    converted = inv && inv.commissionTotal
                        ? inv.commissionTotal
                        : 0;
                }

                totalCommission += parseFloat(inv.commissionTotal);
                totalTax += parseFloat(inv && inv.totalCpTax ? inv.totalCpTax : 0);
                totalGrossReceived += parseFloat(inv && inv.grossPaymentReceived ? inv.grossPaymentReceived : 0);
                totalPaymentBeforeTax += parseFloat(inv && inv.commissionTotalConverted ? inv.commissionTotalConverted : 0);

                if (inv && inv.currency) {
                    currency = inv.currency;
                }
            });
        }

        return (
            <div className='invoice-header'>

                {headerLogo && (
                    <img
                        src={headerLogo}
                        className="invoice-header-logo"
                        alt="Header Logo"
                    />
                )}

                <div className="invoice-content-padding">
                    <h3 className="invoice-heading">Invoice</h3>

                    {/* Invoice Info */}
                    <div className="invoice-number-section">
                        <table className='invoice-table'>
                            <tbody>
                                <tr>
                                    <td className='invoice-table-body' style={{ backgroundColor: '#f2f2f2', width: "40%" }}>
                                        <strong>Invoice No.</strong>
                                    </td>
                                    <td className='invoice-table-body'>
                                        <strong>{generatedInvoice.invoiceNumber}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='invoice-table-body' style={{ backgroundColor: "#f2f2f2" }}>
                                        <strong>Date</strong>
                                    </td>
                                    <td className='invoice-table-body'>
                                        {moment(generatedInvoice.invoiceGeneratedDate).format(dateFormat)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Invoice To & From */}
                    <div className="invoice-address-container">
                        <table style={{ width: '48%', float: 'left' }} className="invoice-address-table">
                            <thead><tr><th className='invoice-table-heading' colspan="2">Invoice To</th></tr></thead>
                            <tr><td className='invoice-table-heading' style={{ width: '30%' }}>Name</td><td className='invoice-table-body'><strong>{generatedInvoice.invoiceToName}</strong></td></tr>
                            <tr><td className='invoice-table-heading'>Address</td><td className='invoice-table-body'>{generatedInvoice.invoiceAddress}</td></tr>
                            <tr><td className='invoice-table-heading'>Attention</td><td className='invoice-table-body'>{generatedInvoice.kindAttention}</td></tr>
                            <tr><td className='invoice-table-heading'>Email/Ph.</td><td className='invoice-table-body'>{generatedInvoice.invoiceToEmail}<br />{generatedInvoice.invoiceToPhone}</td></tr>
                            {
                                generatedInvoice.hasConversionRate && generatedInvoice.invoiceThroughCp && (
                                    <>
                                        <tr><td className='invoice-table-heading'>GSTIN</td><td className='invoice-table-body'>{invoiceToDetail && invoiceToDetail.gstNumber}</td></tr>
                                        <tr><td className='invoice-table-heading'>PAN</td><td className='invoice-table-body'>{invoiceToDetail && invoiceToDetail.panNumber}</td></tr>
                                    </>
                                )
                            }
                        </table>
                        <table style={{ width: '48%', float: 'right' }} className="invoice-address-table">
                            <thead><tr><th className='invoice-table-heading' colspan="2">Invoice From</th></tr></thead>
                            <tr><td className='invoice-table-heading' style={{ width: '30%' }}>Name</td><td className='invoice-table-body'><strong>{companyDetails && companyDetails.companyName}</strong></td></tr>
                            <tr><td className='invoice-table-heading'>Address</td><td className='invoice-table-body'>{companyDetails && companyDetails.companyAddress}</td></tr>
                            <tr><td className='invoice-table-heading'>Email</td><td className='invoice-table-body'>{financeEmail}</td></tr>
                            <tr><td className='invoice-table-heading'>Contact</td><td className='invoice-table-body'>{companyDetails && companyDetails.companyPhoneCode ? companyDetails.companyPhoneCode : ''}{companyDetails && companyDetails.companyPhone ? companyDetails.companyPhone : 'N/A'}</td></tr>
                            {
                                generatedInvoice.hasConversionRate && generatedInvoice.invoiceThroughCp && (
                                    <>
                                        <tr><td className='invoice-table-heading'>GSTIN</td><td className='invoice-table-body'>{companyDetails && companyDetails.companyGst}</td></tr>
                                        <tr><td className='invoice-table-heading'>PAN</td><td className='invoice-table-body'>{companyDetails && companyDetails.companyPan}</td></tr>
                                    </>
                                )
                            }
                        </table>
                        <div style={{ clear: 'both' }}></div>
                    </div>

                    {/* Main Table */}
                    <table style={{ marginTop: '25px' }} className='invoice-table'>
                        <thead>
                            <tr>
                                <th className='invoice-table-heading'>Student Details</th>
                                <th className='invoice-table-heading'>University & Course</th>
                                <th className='invoice-table-heading'>Term</th>
                                <th className='invoice-table-heading'>Tuition Fee</th>
                                <th className='invoice-table-heading'>%Age</th>
                                <th className='invoice-table-heading'>Commission</th>

                                {
                                    generatedInvoice && generatedInvoice.hasConversionRate &&
                                    <>
                                        <th className='invoice-table-heading'>Conv. Rate</th>
                                        {
                                            generatedInvoice && generatedInvoice.hasBankCharges && generatedInvoice.bankCharges && (
                                                <th className='invoice-table-heading'>Bank Charges ({companyDetails.companyCurrency})</th>
                                            )
                                        }
                                        <th className='invoice-table-heading'>Conv. Amount ({companyDetails.companyCurrency})</th>

                                        {/* <th className='invoice-table-heading'>
                                            Net ({companyDetails.companyCurrency})
                                        </th> */}
                                    </>
                                }
                            </tr>
                        </thead>

                        <tbody>
                            {
                                generatedInvoice &&
                                generatedInvoice.invoices &&
                                generatedInvoice.invoices.map(function (inv, index) {
                                    return (
                                        <tr key={index}>

                                            <td>
                                                ID: {inv && inv.inquiry && inv.inquiry.visaDesk && inv.inquiry.visaDesk.selectedCourse && inv.inquiry.visaDesk.selectedCourse.instituteStudentId ? inv.inquiry.visaDesk.selectedCourse.instituteStudentId : "N/A"}
                                                <br />
                                                <strong>
                                                    {inv && inv.inquiry && inv.inquiry.studentName
                                                        ? inv.inquiry.studentName
                                                        : "N/A"}
                                                </strong>
                                                <br />

                                                Passport:
                                                {inv &&
                                                    inv.inquiry &&
                                                    inv.inquiry.visaDesk &&
                                                    inv.inquiry.visaDesk.passportNo
                                                    ? inv.inquiry.visaDesk.passportNo
                                                    : "N/A"}
                                                <br />

                                                DOB:
                                                {inv && inv.inquiry && inv.inquiry.dateOfBirth
                                                    ? moment(inv.inquiry.dateOfBirth).format(dateFormat)
                                                    : "N/A"}
                                            </td>

                                            <td>
                                                {inv && inv.inquiry && inv.inquiry.visaDesk && inv.inquiry.visaDesk.selectedCourse && inv.inquiry.visaDesk.selectedCourse.universityInstitutionName
                                                    ? inv.inquiry.visaDesk.selectedCourse.universityInstitutionName
                                                    : 'N/A'}
                                                <br />

                                                <span style={{ color: '#666' }}>
                                                    {inv && inv.courseName ? inv.courseName : 'N/A'}
                                                </span>
                                                <br />

                                                {inv && inv.courseStartDate ? (
                                                    <span>
                                                        <strong>Start:</strong> {moment(inv.courseStartDate).format(dateFormat)}
                                                    </span>
                                                ) : null}
                                            </td>

                                            <td>
                                                {inv && inv.termNumber ? inv.termNumber : "N/A"}
                                            </td>

                                            <td>
                                                {inv && inv.tutionFee
                                                    ? inv.tutionFee + " (" + (inv.currency ? inv.currency : "") + ")"
                                                    : "N/A"}
                                            </td>

                                            <td>
                                                {inv && inv.commissionFromCourse
                                                    ? `${inv.commissionFromCourse} ${inv.commissionTypeFrom === 'Percentage'
                                                        ? '(%)'
                                                        : inv.commissionTypeFrom === 'Flat'
                                                            ? '(Flat)'
                                                            : ''
                                                    }`
                                                    : 'N/A'}
                                            </td>

                                            <td>
                                                {inv && inv.commissionTotal
                                                    ? Number(inv.commissionTotal).toFixed(2)
                                                    : '0.00'}
                                            </td>

                                            {
                                                generatedInvoice && generatedInvoice.hasConversionRate &&
                                                <>
                                                    <td>{inv && inv.conversionRate ? inv.conversionRate : 0}</td>
                                                    {
                                                        generatedInvoice && generatedInvoice.hasBankCharges && generatedInvoice.bankCharges && (
                                                            <td>{studentBankCharge ? studentBankCharge : 0}</td>
                                                        )
                                                    }
                                                    <td>
                                                        {
                                                            generatedInvoice.taxPaidBy === "Company"
                                                                ? (inv && inv.grossPaymentReceived
                                                                    ? inv.grossPaymentReceived
                                                                    : 0)
                                                                : (inv && inv.commissionTotalConverted
                                                                    ? inv.commissionTotalConverted
                                                                    : 0)
                                                        }
                                                    </td>
                                                    {/* <td>{inv && inv.grossPaymentReceived ? inv.grossPaymentReceived : 0}</td> */}
                                                    {/* <td>{inv && inv.commissionTotalConverted ? inv.commissionTotalConverted : 0}</td> */}
                                                </>
                                            }

                                        </tr>
                                    );
                                })
                            }

                            {/* Grand Total */}
                            <tr className="invoice-total-row">
                                <td colSpan="5" style={{ textAlign: "right" }}>
                                    <strong>Grand Total</strong>
                                </td>

                                <td>
                                    {totalCommission.toFixed(2)} ({currency})
                                </td>

                                {
                                    generatedInvoice && generatedInvoice.hasConversionRate &&
                                    <>
                                        <td></td>
                                        {
                                            generatedInvoice && generatedInvoice.hasBankCharges && generatedInvoice.bankCharges && (
                                                <td></td>
                                            )
                                        }
                                        {/* <td>{totalCommission.toFixed(2)} ({companyDetails.companyCurrency})</td> */}
                                        {/* <td>{totalGrossReceived.toFixed(2)} ({companyDetails.companyCurrency})</td> */}
                                        <td>
                                            {
                                                generatedInvoice.taxPaidBy === "Company"
                                                    ? totalGrossReceived.toFixed(2)
                                                    : totalPaymentBeforeTax.toFixed(2)
                                            }
                                            {" "}
                                            ({companyDetails.companyCurrency})
                                        </td>
                                    </>
                                }
                            </tr>
                        </tbody>
                    </table>

                    {/* Tax Summary */}
                    {
                        generatedInvoice &&
                        generatedInvoice.hasConversionRate &&
                        combinedTaxString !== "" &&
                        <>
                            <div style={{ width: "40%", float: "right", marginTop: "10px" }}>
                                <table className='invoice-table'>
                                    <tbody>
                                        <tr>
                                            <td className='invoice-table-heading' >
                                                Net Taxable Value
                                            </td>
                                            <td className='invoice-table-body' style={{ textAlign: "right" }}>
                                                {totalPaymentBeforeTax} ({companyDetails.companyCurrency})
                                            </td>
                                        </tr>
                                        {
                                            generatedInvoice && generatedInvoice.cpTaxDetails.map((tax) => (
                                                <tr>
                                                    <td className='invoice-table-heading'>
                                                        Add: {tax.taxName} ({tax.taxValue}%)
                                                    </td>
                                                    <td className='invoice-table-body' style={{ textAlign: "right" }}>
                                                        {tax.totalTax} ({companyDetails.companyCurrency})
                                                    </td>
                                                </tr>
                                            ))
                                        }


                                        <tr className="total-row">
                                            <td className='invoice-table-heading' style={{ backgroundColor: "#e6e6e6" }}>
                                                {generatedInvoice && generatedInvoice.additionalDeduction ? 'Amount Before Add. Deduction' : 'Total Invoice Value'}
                                            </td>
                                            <td className='invoice-table-body' style={{ textAlign: "right" }}>
                                                {totalGrossReceived && totalGrossReceived.toFixed(2)} ({companyDetails.companyCurrency})
                                            </td>
                                        </tr>
                                        {
                                            generatedInvoice && generatedInvoice.additionalDeduction && generatedInvoice.additionalTaxDetails && (
                                                <>
                                                    {
                                                        generatedInvoice.additionalTaxDetails.map((tax) => (
                                                            <tr key={tax.taxName}>
                                                                <td className='invoice-table-heading'>
                                                                    Less: {tax.taxName.replace('%', '').trim()} ({Math.abs(Number(tax.taxValue))}%)
                                                                </td>
                                                                <td className='invoice-table-body' style={{ textAlign: "right" }}>
                                                                    {tax.totalTax} ({companyDetails.companyCurrency})
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                    <tr className="total-row">
                                                        <td className='invoice-table-heading' style={{ backgroundColor: "#e6e6e6" }}>
                                                            Total Invoice Value
                                                        </td>
                                                        <td className='invoice-table-body' style={{ textAlign: "right" }}>
                                                            {parseFloat(totalGrossReceived) - parseFloat(Math.abs(totalAddtionalDeduction))} ({companyDetails.companyCurrency})
                                                        </td>
                                                    </tr>
                                                </>

                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ clear: "both" }}></div>
                        </>
                    }

                    <div className="invoice-section-bar">Bank Details for Transfer</div>
                    {bankDetail && (
                        <table className='invoice-table'>
                            <tbody>
                                <tr>
                                    <td className='invoice-table-heading' style={{ width: "30%", backgroundColor: "#f9f9f9" }}>
                                        Bank Name
                                    </td>
                                    <td className='invoice-table-body'>
                                        {bankDetail.bankName ? bankDetail.bankName : ''}
                                    </td>
                                </tr>

                                <tr>
                                    <td className='invoice-table-heading' style={{ backgroundColor: "#f9f9f9" }}>
                                        Branch & Address
                                    </td>
                                    <td className='invoice-table-body'>
                                        {bankDetail.bankAddress ? bankDetail.bankAddress : ''}
                                    </td>
                                </tr>

                                <tr>
                                    <td className='invoice-table-heading' style={{ backgroundColor: "#f9f9f9" }}>
                                        Account Number / IBAN
                                    </td>
                                    <td className='invoice-table-body'>
                                        <strong>
                                            {bankDetail.accountNumber ? bankDetail.accountNumber : ''}
                                        </strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td className='invoice-table-heading' style={{ backgroundColor: "#f9f9f9" }}>
                                        Account Name
                                    </td>
                                    <td className='invoice-table-body'>
                                        <strong>
                                            {bankDetail.accountName ? bankDetail.accountName : ''}
                                        </strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td className='invoice-table-heading' style={{ backgroundColor: "#f9f9f9" }}>
                                        SWIFT / BIC Code
                                    </td>
                                    <td className='invoice-table-body'>
                                        {bankDetail.bankSwiftBicCode ? bankDetail.bankSwiftBicCode : ''}
                                    </td>
                                </tr>

                                <tr>
                                    <td className='invoice-table-heading' style={{ backgroundColor: "#f9f9f9" }}>
                                        IFSC Code
                                    </td>
                                    <td className='invoice-table-body'>
                                        {bankDetail.bankIfscCode ? bankDetail.bankIfscCode : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}

                    <div style={{ marginTop: "15px", border: "1px dashed #ccc", padding: "8px" }}>
                        <strong>Note:</strong> Please quote{" "}
                        <strong>
                            "{generatedInvoice && generatedInvoice.invoiceNumber ? generatedInvoice.invoiceNumber : ''}"
                        </strong>{" "}
                        as reference while transferring funds and notify via email to{" "}
                        <strong>
                            {financeEmail ? financeEmail : ''}
                        </strong>
                    </div>

                    {/* Sign With Stamp */}
                    <div className="invoice-sign-section">
                        {/* <p>Thanks and Best Regards,</p>
                        {footerStemp && (
                            <img src={footerStemp} alt="Sign With Stamp" style={{ height: '70px', width: 'auto', margin: '10px 0' }} />
                        )} */}
                        <div style={{ marginTop: '20px', padding: '10px', 'border-top': '1px solid #eee', fontStyle: 'italic', color: '#888', textAlign: 'center', fontSize: '12px' }}>
                            This is a system-generated invoice and does not require a signature..
                        </div>
                        {/* <div>
                            <strong>Sushil K. Bharti</strong><br />
                            Director - Finance
                        </div> */}
                    </div>
                    <div className='footer'>
                        {footerLogo ?
                            <img
                                src={footerLogo}
                                className="invoice-header-logo"
                                alt="Footer Logo"
                            /> :
                            <table style={{ width: '100%', border: 'none' }}>
                                <tr>
                                    <td style={{ width: '50%', border: 'none' }}>
                                        <strong style={{ color: '#444' }}>Corporate Office</strong><br />
                                        <div dangerouslySetInnerHTML={{ __html: corporateOffice || '' }} />
                                    </td>

                                    <td style={{ width: '50%', border: 'none', textAlign: 'right' }}>
                                        <strong style={{ color: '#444' }}>Registered Office</strong><br />
                                        <div dangerouslySetInnerHTML={{ __html: registeredOffice || '' }} />
                                    </td>
                                </tr>
                            </table>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default InvoicePDF;